<template>
    <div class="block-boy">
        <p class="block-boy__text block-boy__text-one">
            В 9–10 лет у ребенка могут появиться первые серьезные увлечения. Не важно, наука это или шахматы — его физическая активность должна быть регулярной. Например, современные <a href="https://www.pik.ru/deti/parks?utm_source=pikabu.ru&utm_campaign=general&utm_medium=referral&utm_content=timeline" class="app__link app__link--red" target="_blank">скейт-парки</a> — отличное место тренировать равновесие, выносливость и ловкость. Так что если десятилетний ребенок отказывается играть среди малышни, купите ему скейт или ролики.
        </p>
        <BlockParallax
            fixed
            speed="10"
            direction="top"
            transform="translateY"
            class="block-boy__img--mobile"
        >
            <div class="block-boy__img-caja">
                <img
                    src="../assets/5-img-copy.jpg"
                    class="block-boy__img block-boy__img block-boy__img-one"
                />
                <div class="image-caption image-caption--overlap-right">Скейт-парк в проекте <br>«Мещерский лес»</div>
            </div>
        </BlockParallax>

        <BlockParallax
            class="block-boy__img-box"
            fixed
            speed="8"
            offset="350"
            direction="top"
            transform="translateY"
        >
            <img
                src="../assets/6-img-copy.jpg"
                class="block-boy__img block-boy__img-two"
            />
            <div class="image-caption">Скейт-парк в проекте «Бунинские луга»</div>
        </BlockParallax>
        
        <BlockParallax class="block-boy__icon block-boy__icon--skate-2 block-boy--icon-desktop" speed="5" direction="left">
            <img src="@/assets/images/icons/skate-2.png">
        </BlockParallax>
        <BlockParallax class="block-boy__icon block-boy__icon--ball block-boy--icon-desktop" speed="1" direction="left">
            <img src="@/assets/images/icons/ball.png">
        </BlockParallax>
        <BlockParallax class="block-boy__icon block-boy__icon--nb block-boy--icon-desktop" speed="3">
            <img src="@/assets/images/icons/nb-2.png">
        </BlockParallax>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'
export default {
    components: {
        BlockParallax
    }
}
</script>

<style scoped lang="stylus">
.block-boy {
    display flex
    flex-direction column
    +layout-md-and-up() {
        position relative
        margin-top 5rem
    }
    &__text {
        margin 2rem 0 0 0
        font-size 1.5rem
        line-height 1.47
        letter-spacing 0.16px
        color $color-text
        padding-left 5rem
        +layout-md-and-up() {
            max-width 45rem
            padding-left: 8rem
        }
        +layout-l-and-up() {
            max-width 43.4rem
        }
    }
    &__text-one {
        +layout-md-and-up() {
            order: 1
        }
    }
    &__text-two {
        margin-top 2.6rem
        +layout-md-and-up() {
            order: 2
        }

    }
    &__img {
        &--mobile {
            +layout-xs() {
                text-align right
            }
        }
        +layout-md-and-up() {
            &-caja {
                order 3
                position: absolute
                top: 0
                right: 2rem
                margin-top 0
            }
        }
    }
    &__img-one {
        margin-top 3rem
        width: calc(100% - 1rem)
        margin-right: -2rem
        margin-left: auto
        +layout-sm-and-up() {
            width auto
        }
    }
    &__img-box {
        margin-top 2.5rem
        margin-left -1rem
        margin-right -1rem
        +layout-sm-and-up() {
            width auto
        }
        +layout-md-and-up() {
            order 4
            margin-left 0
            margin-right 0
            max-width 62rem
        }
    }
    &__img-two {
        object-fit cover
        width 100%
        max-width 100%
        +layout-md-and-up() {
            position: relative
            z-index 5
            max-width 62.5rem
            margin-top 3.7rem
        }
    }
    
    &__icon {
        position absolute
        max-width 100%
    }

    &__icon--nb {
        +layout-md-and-up() {
            top 47rem
            right 4rem
        }
    }

    &__icon--ball {
        +layout-md-and-up() {
            top 10rem
            left -16rem
        }
    }
    
    &__icon--skate-2 {
        +layout-md-and-up() {
            top -11rem
            right -17rem
        }
    }

    &--icon-desktop {
        display none
        +layout-md-and-up() {
            display block
        }
    }
}
.image-caption {
    &--overlap-right {
        padding-left 26%
    }
}
</style>
